function StaffData(state = { agentList: [], relatedStaffs: [], middlemanList:[] }, action) {

  switch (action.type) {

    case "GET_AGENT_LIST":
      return {
        ...state,
        agentList: action.data
      };
    case "GET_RELATEDSTAFFS":
      return {
        ...state,
        agentList: action.data
      };
      case "GET_MIDDLEMAN_LIST":
        return{
          ...state,
          middlemanList: action.data
        }
    default:
      return state;
  }
}
export default StaffData;